import AnyChart from 'anychart-react';
import classNames from 'classnames';
import React from 'react';
import {connect} from 'react-redux';
import swal from 'sweetalert2';
import {fetchSeasonActiveUsers} from '../../../../../actions/entities/statistics/activeUsers';
import earthFlag from '../../../../../assets/img/other/flag-earth.svg';
import Loader from '../../../../../components/Loader';
import './index.css';

class SeasonActiveUsersWidget extends React.Component {
  constructor(props) {
    super(props);
    this.state = {lang: 'ALL'};
  }

  fetchStats() {
    const {isFetching} = this.props;
    if (!isFetching) {
      this.props.dispatch(
        fetchSeasonActiveUsers(null, (type, error) =>
          swal({
            title: `Oops...`,
            type: 'error',
            html:
              `Something went wrong:<br/>"${type}"<br/>${error}<br/>` +
              `<pre><code>${JSON.stringify(error, undefined, 4)}</code></pre>`,
          }),
        ),
      );
    }
  }

  toggleLang(value) {
    const {lang} = this.state;

    if (lang === value) {
      this.setState({lang: 'ALL'});
    } else {
      this.setState({lang: value});
    }
  }

  renderTable() {
    const {data} = this.props;
    if (!data) return false;
    const {lang} = this.state;
    const {
      newActiveUsers,
      newDroppers,
      oldActiveUsers,
      oldDroppers,
    } = data.countries[lang];

    setTimeout(() => {
      const credits = {...document.getElementsByClassName('anychart-credits')};
      credits[0].style.display = 'none';
    }, 1);
    const total =
      (newActiveUsers || 0) +
      (newDroppers || 0) +
      (oldActiveUsers || 0) +
      (oldDroppers || 0);
    return (
      <div className="chartContainer">
        <AnyChart
          type="pie"
          data={[
            {
              x: `${
                newActiveUsers ? newActiveUsers.toLocaleString() : 0
              } - New active users`,
              value: newActiveUsers,
              normal: {fill: '#31a531'},
            },
            {
              x: `${
                newDroppers ? newDroppers.toLocaleString() : 0
              } - New users droppers`,
              value: newDroppers,
              normal: {fill: '#afcaae'},
            },
            {
              x: `${
                oldActiveUsers ? oldActiveUsers.toLocaleString() : 0
              } - Old active users`,
              value: oldActiveUsers,
              normal: {fill: '#2c3994'},
            },
            {
              x: `${
                oldDroppers ? oldDroppers.toLocaleString() : 0
              } - Old users droppers`,
              value: oldDroppers,
              normal: {fill: '#acb0c6'},
            },
          ]}
          labels={{fontColor: 'black', fontWeight: 'bold'}}
          legend={{itemsLayout: 'vertical', position: 'right'}}
          width={500}
          height={300}
          fontColor="black"
        />
        <div>{`Total : ${total ? total.toLocaleString() : 0}`}</div>
      </div>
    );
  }

  render() {
    const {lang} = this.state;
    const {isFetching} = this.props;

    return (
      <div id="season-active-users-widget">
        <div className="box">
          <div className="box-header with-border">
            <h3 className="box-title pull-left">
              <i className="fa fa-user-circle-o" /> Season Player Users
            </h3>
          </div>
          <div className="box-body">
            <div className="margin-bottom text-center">
              <div className="inline lang">
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'FR',
                  })}
                  onClick={() => this.toggleLang('FR')}>
                  <span className="flag-icon flag-icon-fr" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'GB',
                  })}
                  onClick={() => this.toggleLang('GB')}>
                  <span className="flag-icon flag-icon-gb" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'ES',
                  })}
                  onClick={() => this.toggleLang('ES')}>
                  <span className="flag-icon flag-icon-es" />
                </button>
                <button
                  className={classNames('btn btn-box-tool', {
                    selected: lang === 'OTHER',
                  })}
                  onClick={() => this.toggleLang('OTHER')}>
                  <img
                    src={earthFlag}
                    alt="Drapeau de la terre"
                    className="flag-img-btn"
                  />
                </button>
              </div>
              <div className="inline data-range-picker">
                <button
                  className="btn btn-default"
                  onClick={() => this.fetchStats()}>
                  <i className="fa fa-refresh" />
                </button>
              </div>
            </div>
            {this.renderTable()}
          </div>
          {isFetching && <Loader />}
        </div>
      </div>
    );
  }
}

export default connect(
  state => state.app.statistics.seasonActiveUsers,
  dispatch => ({dispatch}),
)(SeasonActiveUsersWidget);



// WEBPACK FOOTER //
// ./src/pages/Monitoring/Statistics/Widgets/SeasonActiveUsers/index.js